module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign_4.24217a88.svg";